var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-container",
        { staticClass: "p-3" },
        [
          _c(
            "el-form",
            { attrs: { inline: "" } },
            [
              _c(
                "el-form-item",
                [_c("selectRoleLabel", { on: { onSelect: _vm.onSelectRole } })],
                1
              ),
              _vm.showCom
                ? _c(
                    "el-form-item",
                    [
                      _c("companySelect", {
                        attrs: { id: _vm.company_id },
                        on: {
                          "update:id": function ($event) {
                            _vm.company_id = $event
                          },
                          onSelect: _vm.onSelectCompany,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                [
                  _vm.$route.meta.action.c
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.createUserDialog = true
                              _vm.user = null
                            },
                          },
                        },
                        [_vm._v(" 新增 ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.users,
            stripe: "",
            "row-class-name": _vm.checkSelf,
          },
        },
        [
          _c("el-table-column", { attrs: { prop: "name", label: "姓名" } }),
          _c("el-table-column", {
            attrs: { prop: "description", label: "說明" },
          }),
          _c("el-table-column", { attrs: { prop: "email", label: "email" } }),
          _c("el-table-column", {
            attrs: { label: "角色" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.roles.length
                      ? _c("div", [
                          _vm._v(" " + _vm._s(scope.row.roles[0].name) + " "),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "狀態" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm.disableSelf(scope.row)
                      ? _c("el-switch", {
                          attrs: {
                            "active-color": "#13ce66",
                            "inactive-color": "#ff4949",
                            "active-value": true,
                            "inactive-value": false,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.onSwitchChange(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.status,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "status", $$v)
                            },
                            expression: "scope.row.status",
                          },
                        })
                      : _c("div", [_vm._v("不可用")]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "動作" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return _vm.disableSelf(scope.row) &&
                      _vm.$route.meta.action.u
                      ? [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary", size: "small" },
                              on: {
                                click: function ($event) {
                                  _vm.user = scope.row
                                  _vm.createUserDialog = true
                                },
                              },
                            },
                            [_vm._v("編輯")]
                          ),
                          _vm.$route.meta.action.d
                            ? _c(
                                "el-popconfirm",
                                {
                                  attrs: { title: "確定刪除?" },
                                  on: {
                                    confirm: function ($event) {
                                      return _vm.deleteUser()
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "ml-3",
                                      attrs: {
                                        slot: "reference",
                                        type: "danger",
                                        size: "small",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.user = scope.row
                                        },
                                      },
                                      slot: "reference",
                                    },
                                    [_vm._v("刪除 ")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      : undefined
                  },
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "編輯使用者",
            visible: _vm.createUserDialog,
            width: "80%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.createUserDialog = $event
            },
          },
        },
        [
          _vm.createUserDialog
            ? _c("createUserForm", {
                attrs: { user: _vm.user },
                on: {
                  closeDialog: function ($event) {
                    _vm.createUserDialog = false
                    _vm.user = null
                  },
                  success: function ($event) {
                    return _vm.onSelectRole(_vm.roleLabel)
                  },
                },
              })
            : _vm._e(),
          _c("span", {
            staticClass: "dialog-footer",
            attrs: { slot: "footer" },
            slot: "footer",
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }